import React, { useEffect, useState } from "react";
import closeIcon from "../../Assets/Icons/close.svg";
import envConfig from "../../config/config";

const ProjectListTable = ({ onClose }) => {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        fetch(
            `${envConfig.REACT_APP_APIREPO_READ}/apirepo/v0.1/projects`
        )
            .then((res) => res.json())
            .then((data) => {
                const approvedProjects = data.data.filter(
                    (proj) => proj.status?.currentStatus === "approved"
                );
                setProjects(approvedProjects);
            })
            .catch((err) => console.error("Error fetching project data", err))
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <div className="fixed inset-0 flex pt-5 justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded shadow-custom text-black w-[90vw] h-[90vh] max-w-6xl border border-gray-600 relative z-20">
                {/* Header with Close Button */}
                <div className="sticky top-0 bg-[#002746] text-white h-12 flex items-center justify-between px-4 shadow-custom z-10 mb-4">
                    <h1 className="font-semibold text-lg">Contributing Projects</h1>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        className="border-none hover:bg-slate-700 hover:rounded-full"
                    >
                        <img src={closeIcon} alt="close" className="w-8 h-8" />
                    </button>
                </div>

                {isLoading ? (
                    <div className="flex flex-col items-center justify-center mt-20">
                        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-4 text-gray-700 font-medium">Loading projects...</p>
                    </div>
                ) : (
                    <div className="px-4 max-h-[73vh] min-h-[50vh] overflow-y-auto">
                        <table className="bg-white w-full border max-w-[85vw] border-gray-200">
                            <thead className="text-white border-b border-gray-200">
                                <tr className="bg-[#002746] border-b sticky top-[-1px] border-gray-200">
                                    <th className="text-left p-2 w-[80px] font-bold">Sr No</th>
                                    <th className="text-left p-2 font-bold">Project Name</th>
                                    <th className="text-left p-2 font-bold">Publisher Email</th>
                                    <th className="text-left p-2 font-bold">Total APIs</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white text-black">
                                {projects.map((project, index) => (
                                    <tr key={project.id} className="border-b hover:bg-gray-100">
                                        <td className="p-2">{index + 1}</td>
                                        <td className="p-2">{project.projectName}</td>
                                        <td className="p-2">{project.publisherEmail}</td>
                                        <td className="p-2">{project.apiIds.length}</td>
                                    </tr>
                                ))}
                                {projects.length === 0 && (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4 text-gray-500">
                                            No approved projects found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>)}
            </div>
        </div>
    );
};

export default ProjectListTable;
